import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

type Option<T = string | number> = {
    value: T;
    label: string;
};

export const userAddEditFormFields = (
    isEditMode: boolean,
    roleDropdownData: Option[]
): FormFieldConfig[] => [
        {
            name: "username",
            label: "User",
            type: "text",
            placeholder: "Enter user",
            disabled: isEditMode,
            required: true,
            rules: validations.userAssignment.username,
        },
        {
            name: "roleid",
            label: "Role",
            type: "select",
            options: roleDropdownData,
            placeholder: "Select role",
            disabled: false,
            required: true,
            rules: validations.userAssignment.role,
        }
    ];


export const userList = [
    { key: "username", label: "User",maxLength: 30,tooltip: true },
    { key: "useremail", label: "Email",maxLength: 30,tooltip: true },
    { key: "rolename", label: "Role" },
]


  export const userFields: FormFieldConfig[] = [
    {
      name: "username",
      label: "User Name",
      type: "text",
      placeholder: "Enter user name",
      required: true,
      rules: validations.user.username,
    },
    {
      name: "firstname",
      label: "First Name",
      type: "text",
      placeholder: "Enter first name",
      required: true,
      rules: validations.user.firstname,
    },
    {
      name: "lastname",
      label: "Last Name",
      type: "text",
      placeholder: "Enter last name",
      required: true,
      rules: validations.user.lastname,
    },
    {
      name: "useremail",
      label: "Email",
      type: "email",
      placeholder: "Enter email address",
      required: true,
      rules: validations.user.email,
    },
    {
      name: "contactnumber",
      label: "Contact Number",
      type: "text",
      placeholder: "Enter contact number",
      required: true,
      rules: validations.user.phone,
    },
  ];
